var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Tarefas ✍")]),_c('TaskProgress',{attrs:{"progress":_vm.progress}}),_c('NewTask',{on:{"taskAdded":_vm.addTask}}),_c('TaskGrid',{attrs:{"tasks":_vm.tasks},on:{"taskDeleted":_vm.deleteTask,"taskStateChanged":_vm.toggleTaskState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }